import { render } from "./vote_checkmark.svg?vue&type=template&id=eb41d6e2"
const script = {}
script.render = render

export default script